<template>
	<div>
	<InformationSection id="S100" :sections='information' />
		<AttachmentSection :files='files' v-if='files' />
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'

import InformationSection from '@/components/base/InformationSection'
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	name: 'S-100',

	components: {
		InformationSection,
		AttachmentSection
	},

	metaInfo: {
    title: 'S-100'
  },

	data() {
		return {
			information: [],
			files: []
		}
	},
	async created() {
		const {text, section1, section2, section3, section4, files} = await ContentService.get('S100')

		this.files = files
		this.information.push({ title: '', text })
		this.information.push({ title: 'SERVICE AND COVERAGE', text: section1 })
		this.information.push({ title: 'S-100 FREE TRIAL', text: section2 })
		this.information.push({ title: 'DISTRIBUTION, END-USER SYSTEMS & SECURITY', text: section3 })
		this.information.push({ title: 'TIMELINE, ARTICLES & PROJECTS', text: section4 })
	},
}
</script>

<style>
</style>